// extracted by mini-css-extract-plugin
export default {"question-header":"Gnb_question-header__uIM4H","answer-btn":"Gnb_answer-btn__PrSqy"};